<template>
  <v-container id="login" class="fill-height justify-center" tag="section" justify="center" align="center">
    <v-row align="center" justify="space-between" no-gutter>
      <v-col cols="12" md="5">
        <v-img src="@/assets/logo_hexa.png" alt="Hexa Logo" class="ma-10" />
      </v-col>
      <v-col cols="12" md="5">
        <v-progress-circular :size="70" :width="7" color="cyan lighten-5" indeterminate />
        <general-select-empresa-sistema v-show="false" ref="refSelectEmp" :tipo="'outlined'" :todas="true" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import firebase from '@/Firebase.js';
  import Firestore from '@/Firestore.js';
  import UsuariosService from '@/services/UsuariosService';
  import generateRandomString from '@/utils/generateRandomString.js';

  export default {
    name: 'OidcCopel',
    components: {
      GeneralSelectEmpresaSistema: () => import('@/components/general/SelectEmpresaSistema')
    },
    mounted() {
      this.selectCopelCompany();
      this.microsoftLogin();
    },
    methods: {
      selectCopelCompany() {
        this.$store.dispatch('setEmpresa', 'copel');
      },
      microsoftLogin() {
        // https://firebase.google.com/docs/auth/web/microsoft-oauth?hl=pt-br
        var provider = new firebase.auth.OAuthProvider('microsoft.com');
        provider.setCustomParameters({
          tenant: process.env.VUE_APP_COPEL_TENANT_ID
        });
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(async (result) => {
            const { user } = result;
            const userExists = await this.userExists(user.email);
            if (!userExists) {
              await this.createUser(user);
            }

            await this.$store.dispatch('loginOidcCopel', user);
            await this.$refs.refSelectEmp.changeSelectedEmpresa();

            this.$router.push('/');
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Não foi possível se autenticar na aplicação.', '', { position: 'topRight' });
            this.$router.replace({ name: 'Login' });
          });
      },
      async userExists(email) {
        const querySnapshot = await Firestore.collection('usuarios').where('email', '==', email).get();
        let userExists = false;
        querySnapshot.forEach((doc) => (userExists = doc.data()?.email === email));
        return userExists;
      },
      async createUser(user) {
        const names = user.displayName.split(' ');
        const firstName = names[0];
        delete names[0];

        let postData = {
          email: user.email,
          senha: generateRandomString(8),
          nome: firstName,
          sobrenome: [...names].join(' ')?.trim(),
          uid: user.uid,
          desativado: false,
          admin: false,
          empresasSelecionadas: [await this.getFirebaseEmpresaDocId()],
          microsoftLogin: true
        };

        try {
          await UsuariosService.cadastroUsuarioFirebase(postData);
          await this.postUsuarioHexa(postData);
        } catch (error) {
          console.log(error);
          this.$toast.error('Erro ao salvar o usuário.', '', { position: 'topRight' });
          this.$router.replace({ name: 'Login' });
        }
      },
      async getFirebaseEmpresaDocId() {
        const querySnapshot = await Firestore.collection('empresas').where('url', '==', 'copel').get();
        return querySnapshot.docs[0]?.id || 0;
      },
      async postUsuarioHexa(user) {
        let urlEmpresasSelecionadas = [];
        if (process.env.NODE_ENV === 'production') {
          urlEmpresasSelecionadas.push('https://copel.gestaohexa.com.br/api');
        } else {
          urlEmpresasSelecionadas = [process.env.VUE_APP_API_BASE_URL];
        }

        let postData = {
          ...user,
          nome: user.nome + ' ' + user.sobrenome,
          status: 1
        };

        let requests = [];
        urlEmpresasSelecionadas.forEach((url) => requests.push(this.getPostUsuarioHexaRequest(postData, url)));

        await Promise.all(requests).catch(() => {
          this.$toast.error('Erro ao salvar o usuário.', '', { position: 'topRight' });
          this.$router.replace({ name: 'Login' });
        });
      },
      getPostUsuarioHexaRequest(postData, url) {
        return UsuariosService.postUsuarioFromFirebase(0, postData, url).catch((error) => {
          throw new Error(error);
        });
      }
    }
  };
</script>
